import axios from 'axios';

const webTicketApiClient = axios.create({
  baseURL: process.env.REACT_APP_WEB_API_BASE_URL || 'https://trustapp.in',
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

webTicketApiClient.interceptors.request.use((config) => {
  const csrfToken = sessionStorage.getItem('trust_web_csrf');
  if (csrfToken) {
    config.headers['X-Trust-CSRF-Token'] = csrfToken;
  }
  return config;
});

export default webTicketApiClient;
